module.exports = __webpack_public_path__ + "img/ly.64fd87b5.svg";